import { apiRequest } from './client'
import type { OrganizationDto } from './types'

export type UpdateOrganizationRequest = {
  legalName: string
  tradeName: string
  inn: string
  city: string
  horecaType?: string | null
  productTypeIds?: number[]
}

export const listOrganizations = () => apiRequest<OrganizationDto[]>('/organizations')

export const getOrganization = (organizationId: number) =>
  apiRequest<OrganizationDto>(`/organizations/${organizationId}`)

export const updateOrganization = (organizationId: number, request: UpdateOrganizationRequest) =>
  apiRequest<OrganizationDto>(`/organizations/${organizationId}`, {
    method: 'PATCH',
    body: {
      legal_name: request.legalName,
      trade_name: request.tradeName,
      inn: request.inn,
      city: request.city,
      horeca_type: request.horecaType ?? undefined,
      product_type_ids: request.productTypeIds ?? undefined,
    },
  })
